if (!HTMLCollection.prototype.forEach) {
	HTMLCollection.prototype.forEach = function (callback, thisArg) {
		const thisArgument = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArgument, this[i], i, this);
		}
	};
}
